import { usePageType, usePortfolioContext, useProjectContext, useUserContext } from '~/hooks';
import { Header, Label } from 'semantic-ui-react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { DealStates } from '~/constants';
import { useConversationContext } from '../providers/ConversationProvider';

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  &&& h2 {
    margin-bottom: var(--medium);
  }
`;

export default function MessagingHeader() {
  const { loggedInUser } = useUserContext();
  const { project, projectState } = useProjectContext();
  const dealState = projectState?.dealState ?? 0;
  const { portfolio, portfolioState } = usePortfolioContext();
  const { selectedConversation, isSupportConversation } = useConversationContext();
  const pageType = usePageType();
  const isActive = selectedConversation?.isActive;
  const isInactive = selectedConversation && !selectedConversation.isActive;
  const bidDeadline = portfolio?.bidDeadline ?? project?.bidDeadline ?? project?.portfolio?.bidDeadline;
  const showBidDeadline =
    !!bidDeadline &&
    isActive &&
    (pageType === 'project'
      ? dealState >= DealStates.AWAITING_BID && dealState < DealStates.IN_DILIGENCE
      : portfolioState?.earliestState >= DealStates.AWAITING_BID && portfolioState?.earliestState < DealStates.IN_DILIGENCE);

  const bidDeadlineDisplay = (() => {
    if (!bidDeadline) return null;
    const deadline = utcToZonedTime(bidDeadline, 'UTC');
    return format(deadline, 'M/d/yyyy');
  })();

  let headerName;
  if (!selectedConversation) {
    return null;
  } else if (loggedInUser.isAdmin && isSupportConversation) {
    headerName = <Header as="h2">Support conversation: {selectedConversation.name}</Header>;
  } else if (isSupportConversation) {
    headerName = <Header as="h2">Conversation with {selectedConversation.name}</Header>;
  } else {
    headerName = <Header as='h2'>Conversation with {selectedConversation?.name}{isInactive ? <em> — Inactive Conversation</em> : null}</Header>;
  }

  return (
    <HeaderContainer style={headerName === null ? { marginTop: '-1rem' } : {}}>
      {headerName}
      {showBidDeadline && (
        <Label
          size='medium'
          style={{
            fontSize: '0.875rem',
            padding: 'var(--x-small) var(--small)',
            marginLeft: 'auto',
            marginBottom: 'var(--medium)',
          }}
        >
          {bidDeadlineDisplay}
        </Label>
      )}
    </HeaderContainer>
  );
};